var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pages-wrapper", [
    _c(
      "div",
      { staticClass: "returns-page" },
      [
        _c("h1", { staticClass: "returns-title" }, [
          _vm._v("\n      " + _vm._s(_vm.pageTitle) + "\n    ")
        ]),
        _c("fragment", {
          attrs: { prefetch: "", "slot-name": "return_page_header" }
        }),
        _c("ui-tabs", {
          attrs: { items: _vm.tabs },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }